import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
export function FleetTrucks() {
  // Generate 20 trucks
  const trucks = Array.from({
    length: 20
  }).map((_, i) => {
    const models = ['Ford F-150', 'Chevy Silverado', 'RAM 1500', 'Toyota Tundra', 'GMC Sierra', 'Nissan Titan', 'Ford F-250', 'Chevy Colorado'];
    const years = ['2022', '2023', '2024', '2025'];
    const prices = [55, 60, 65, 70, 75, 80, 85];
    const model = models[i % models.length];
    const year = years[i % years.length];
    const price = prices[i % prices.length];
    const imageIds = ['1583267746897-2cf415887172', '1558618666-fcd25c85f82e', '1544636331-e26879cd4d9b', '1612544448445-b8232cff3b6c', '1559348349-8d68f60d544c'];
    const imageId = imageIds[i % imageIds.length];
    return {
      id: i,
      name: `${model} Modified`,
      year,
      price: `$${price}/hr`,
      description: `Rugged ${model} featuring heavy-duty wheelchair lifts and large cargo beds, perfect for affordable transport or shipping oversized medical equipment.`,
      image: `https://images.unsplash.com/photo-${imageId}?w=600&h=400&fit=crop&q=80&sig=${i}`
    };
  });
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-515">
      <div className="bg-white py-12 border-b border-warm-200 mb-12" data-id="element-516">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-517">
          <Link to="/fleet" className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium mb-6 transition-colors" data-id="element-518">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-519" /> Back to Fleet Overview
          </Link>
          <h1 className="text-4xl font-extrabold text-black mb-4" data-id="element-520">
            Wheelchair Accessible Trucks
          </h1>
          <p className="text-lg text-warm-600 max-w-3xl" data-id="element-521">
            Browse our complete inventory of modified pickup trucks offering
            rugged capability without compromising on accessibility.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-523">
          {trucks.map(vehicle => <Card key={vehicle.id} className="rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border-none bg-white flex flex-col h-full" data-id="element-524">
              <img src={vehicle.image} alt={vehicle.name} className="w-full h-48 object-cover" data-id="element-525" />
              <CardBody className="p-6 flex flex-col flex-grow" data-id="element-526">
                <div className="flex justify-between items-start mb-2" data-id="element-527">
                  <h3 className="text-xl font-bold text-black leading-tight" data-id="element-528">
                    {vehicle.name}
                  </h3>
                  <span className="bg-warm-100 text-warm-800 text-xs font-bold px-2 py-1 rounded" data-id="element-529">
                    {vehicle.year}
                  </span>
                </div>
                <p className="text-primary-600 font-bold text-lg mb-3" data-id="element-530">
                  {vehicle.price}
                </p>
                <p className="text-warm-600 text-sm mb-6 flex-grow" data-id="element-531">
                  {vehicle.description}
                </p>
                <div className="flex gap-3 mt-auto items-stretch" data-id="element-532">
                  <Link to="/booking" className="flex-1 flex" data-id="element-533">
                    <Button variant="primary" size="sm" className="w-full h-full" data-id="element-534">
                      Call
                    </Button>
                  </Link>
                  <Link to="/booking" className="flex-1 flex" data-id="element-535">
                    <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-536">
                      Hire Now
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>)}
        </div>

        <div className="mt-20 bg-black rounded-3xl p-10 text-center text-white shadow-2xl" data-id="element-537">
          <h2 className="text-3xl font-bold mb-4" data-id="element-538">
            Need help choosing the right truck?
          </h2>
          <p className="text-warm-400 mb-8 max-w-2xl mx-auto" data-id="element-539">
            Our mobility specialists are available 24/7 to help you find the
            perfect vehicle for your specific needs.
          </p>
          <a href="tel:2404132157" data-id="element-540">
            <Button size="lg" className="bg-primary-600 hover:bg-primary-700 text-white border-none" data-id="element-541">
              <Phone className="w-5 h-5 mr-2" data-id="element-542" /> Call (240) 413-2157
            </Button>
          </a>
        </div>
      </div>
    </div>;
}